import React, { Component } from 'react';
import Utils from "../Utils";
import './home/Home.css';
import { Cargando } from './estados/Cargando';
import { SinDatos } from './estados/SinDatos';
import { DetalleScore } from './proveedor/DetalleScore';


export class Test extends Component {
  static displayName = Test.name;

    constructor(props) {
        super(props);

        this.state = {
            proveedor: {},
            estado: 1
        };
        this.getProveedor();
    }
    

    async getProveedor() {
        this.setState({ estado: 1 })
        await Utils.getProveedor()
            .then(data => {
                if (data !== undefined)
                    this.setState({ proveedor: data, estado: 2 })
            }
            )
    }


    render() {
        switch (this.state.estado) {
            case 1: return (<Cargando></Cargando>);
            case 2: 
                if (this.state.proveedor.Id === 0)
                    return (<SinDatos></SinDatos>);
                else return (
                    <DetalleScore proveedor={this.state.proveedor}></DetalleScore>
                );
            default: ;
        }
    }
}